import React, { useState, useEffect } from "react";

const Disclosures = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallMobile, setIsSmallMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallMobile(window.innerWidth <= 480);
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Check initial size
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#2c2c2c",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isSmallMobile ? "8px" : isMobile ? "15px" : "40px",
    backgroundColor: "#ffffff",
    minHeight: "100vh",
  };

  const contentStyle = {
    backgroundColor: "white",
    padding: isSmallMobile ? "15px" : isMobile ? "25px" : "60px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <style>
          {`
            .disclosures ul,
            .disclosures ol {
              text-align: left !important;
              padding-left: 30px !important;
              margin: 20px 0 !important;
            }
            .disclosures li {
              text-align: left !important;
              margin: 12px 0 !important;
              line-height: 1.6;
            }
            .disclosures h1, .disclosures h2, .disclosures h3, .disclosures h4 {
              text-align: left !important;
              font-family: Arial, Helvetica, sans-serif;
              font-weight: 400;
              margin-top: 40px;
              margin-bottom: 20px;
            }
            .disclosures h1 {
              font-size: 2.2em;
              margin-bottom: 30px;
              border-bottom: 2px solid #333;
              padding-bottom: 15px;
            }
            .disclosures h2 {
              font-size: 1.5em;
              margin-top: 50px;
              border-bottom: 1px solid #ccc;
              padding-bottom: 10px;
            }
            .disclosures h3 {
              font-size: 1.2em;
              margin-top: 35px;
            }
            .disclosures h4 {
              font-size: 1.1em;
              margin-top: 25px;
            }
            .disclosures p {
              margin: 16px 0;
              text-align: justify;
            }
            
            /* Mobile Responsive Styles */
            @media (max-width: 768px) {
              .disclosures h1 {
                font-size: 1.8em !important;
                margin-top: 20px !important;
                margin-bottom: 15px !important;
                padding-bottom: 10px !important;
              }
              .disclosures h2 {
                font-size: 1.3em !important;
                margin-top: 25px !important;
                margin-bottom: 10px !important;
                padding-bottom: 8px !important;
              }
              .disclosures h3 {
                font-size: 1.1em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .disclosures h4 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 8px !important;
              }
              .disclosures p {
                margin: 8px 0 !important;
              }
              .disclosures ul,
              .disclosures ol {
                padding-left: 20px !important;
                margin: 10px 0 !important;
              }
              .disclosures li {
                margin: 6px 0 !important;
              }
            }
            
            @media (max-width: 480px) {
              .disclosures h1 {
                font-size: 1.6em !important;
                margin-top: 15px !important;
                margin-bottom: 12px !important;
              }
              .disclosures h2 {
                font-size: 1.2em !important;
                margin-top: 20px !important;
                margin-bottom: 8px !important;
              }
              .disclosures h3 {
                font-size: 1.05em !important;
                margin-top: 15px !important;
                margin-bottom: 6px !important;
              }
              .disclosures h4 {
                font-size: 1em !important;
                margin-top: 12px !important;
                margin-bottom: 6px !important;
              }
              .disclosures p {
                margin: 6px 0 !important;
              }
              .disclosures ul,
              .disclosures ol {
                padding-left: 15px !important;
                margin: 8px 0 !important;
              }
              .disclosures li {
                margin: 4px 0 !important;
              }
            }
          `}
        </style>
        <div className="disclosures">
          <h1>KinShield Application Disclosures</h1>

          <div
            style={{
              backgroundColor: "#f8f8f8",
              padding: "25px",
              border: "1px solid #ddd",
              marginBottom: "40px",
            }}
          >
            <p style={{ margin: "0 0 10px 0" }}>
              <strong>Effective Date:</strong> November 2025
            </p>
            <p style={{ margin: "0" }}>
              <strong>Last Updated:</strong> March 16, 2026
            </p>
          </div>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              General Information Notice
            </h2>
            <p>
              The content and features provided by KinShield, a service of
              Reliable IT Associates, LLC ("Company," "we," "us," or "our"), are
              intended solely for educational and informational purposes
              regarding digital security awareness and scam detection. The sole
              and exclusive purpose of KinShield is to educate users about the
              mechanisms, tactics, and techniques that scammers, fraudsters, and
              cybercriminals use so that users can better spot and avoid scams.
              This application does not constitute professional cybersecurity
              consulting, legal advice, financial advice, personal advice,
              medical advice, or comprehensive security assessment services.
              Users should not rely on KinShield as their sole source of
              protection against digital threats or fraudulent activities.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Accuracy and Completeness Disclaimer
            </h2>
            <p>
              KinShield extensively uses artificial intelligence ("AI") and
              machine learning technologies, including large language models
              (LLMs), computer vision models, natural language processing (NLP),
              and automated analysis engines provided by third-party AI service
              providers, to analyze potential threats and provide educational
              content. While we endeavor to provide accurate and helpful
              analyses, we cannot guarantee the absolute accuracy, completeness,
              or reliability of our AI-powered detection and analysis systems.
              Users must understand and acknowledge the following:
            </p>
            <ul style={{ textAlign: "left", paddingLeft: "20px" }}>
              <li>
                <strong>AI Can Make Mistakes:</strong> AI-generated analyses,
                assessments, and recommendations may contain errors,
                inaccuracies, omissions, or misleading information. AI
                technology is inherently probabilistic and does not guarantee
                correct or complete results.
              </li>
              <li>
                <strong>AI May Use Outdated Information:</strong> AI models are
                trained on data up to a certain date and may not reflect the
                most current scam tactics, techniques, legal requirements, or
                real-world developments. Scam methodologies evolve continuously
                and AI models may not recognize the latest or most sophisticated
                threats.
              </li>
              <li>
                <strong>
                  AI May Produce False Positives or False Negatives:
                </strong>{" "}
                AI analysis may incorrectly flag legitimate communications as
                scams (false positives) or fail to identify actual scam attempts
                (false negatives). Users should never rely solely on AI analysis
                to determine the legitimacy of any communication, transaction,
                or interaction.
              </li>
              <li>
                <strong>AI Hallucinations:</strong> AI models may generate
                plausible-sounding but factually incorrect information,
                fabricated details, or misleading conclusions. This is an
                inherent limitation of current AI technology.
              </li>
              <li>
                <strong>No Guarantee of Detection:</strong> KinShield does not
                guarantee that its AI systems will detect all scams, fraud
                attempts, phishing schemes, or malicious communications.
              </li>
              <li>
                <strong>AI Is a Tool, Not a Substitute for Judgment:</strong>{" "}
                AI-generated results are intended to assist and educate users,
                not to replace the user's own critical thinking, judgment, or
                independent verification.
              </li>
              <li>
                <strong>Third-Party AI Providers:</strong> User-submitted
                content may be processed by third-party AI service providers.
                KinShield uses PII detection and redaction technology to protect
                personally identifiable information before AI processing where
                applicable, but cannot guarantee that all personal information
                will be successfully identified and redacted.
              </li>
            </ul>
            <p>
              Reliable IT Associates, LLC makes reasonable efforts to maintain
              current threat detection capabilities but assumes no
              responsibility for undetected threats or false positive results.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              User Responsibility and Independent Verification
            </h2>
            <p>
              Users are strongly encouraged to exercise personal judgment and
              seek additional verification when evaluating potentially
              suspicious communications. KinShield's analysis should supplement,
              not replace, critical thinking and due diligence. For matters
              involving significant financial decisions, legal concerns, or
              complex security situations, users should consult with qualified
              professionals including cybersecurity experts, financial advisors,
              or legal counsel as appropriate.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Third-Party Content and External Links
            </h2>
            <p>
              KinShield may reference external websites, resources, or
              third-party services for educational purposes. KinShield
              integrates with the following categories of third-party services:
              AI providers (Anthropic Claude, OpenAI), payment processing
              (Stripe), email delivery (SendGrid), SMS and phone services
              (Twilio), cloud infrastructure (Amazon Web Services), URL threat
              intelligence (Google Safe Browsing API, PhishTank), phone number
              validation (IPQualityScore and other providers), PII detection
              (AWS Comprehend), document OCR (AWS Textract), virus scanning
              (ClamAV), browser fingerprinting (FingerprintJS), and workflow
              automation (n8n). Reliable IT Associates, LLC does not endorse,
              monitor, or assume responsibility for the content, privacy
              practices, or security measures of external sites or third-party
              services. Users access third-party resources at their own risk and
              should review the terms and privacy policies of any external
              services they choose to use.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Technology Limitations
            </h2>
            <p>
              Artificial intelligence and automated threat detection systems
              have inherent limitations. KinShield's capabilities depend on
              training data, algorithmic models, and computational resources
              that may not cover every possible threat scenario. Users should
              understand that no automated system can provide perfect protection
              against all forms of digital fraud or malicious activities.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Data Privacy and Security
            </h2>
            <p>
              While KinShield implements security measures to protect user data,
              no digital service can guarantee absolute security. Users should
              review our Privacy Policy for detailed information about data
              collection, processing, and protection practices. By using
              KinShield, users acknowledge understanding of our data handling
              procedures.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Service Availability and Updates
            </h2>
            <p>
              KinShield services may experience occasional downtime for
              maintenance, updates, or technical issues. Reliable IT Associates,
              LLC reserves the right to modify, suspend, or discontinue features
              without prior notice. Users should not rely solely on KinShield's
              availability for time-sensitive security decisions.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Professional Consultation Recommendation
            </h2>
            <p>
              For comprehensive cybersecurity planning, incident response, or
              complex threat analysis, users should engage qualified
              cybersecurity professionals. KinShield is designed to enhance
              awareness and provide preliminary threat assessment, not to
              replace professional security services.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Not Law Enforcement or Professional Advice
            </h2>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "20px",
                margin: "20px 0",
              }}
            >
              <p>
                <strong>
                  KINSHIELD IS NOT A LAW ENFORCEMENT AGENCY, GOVERNMENT ENTITY,
                  OR REGULATORY BODY.
                </strong>{" "}
                KinShield does not have the authority, ability, or obligation to
                investigate crimes, apprehend criminals, enforce laws, or take
                any law enforcement action. KinShield does not directly
                intervene in or prevent ongoing scam attempts or fraud schemes.
                If you believe you are the victim of a crime, you should contact
                local law enforcement, the Federal Trade Commission (FTC), the
                FBI Internet Crime Complaint Center (IC3), or other appropriate
                governmental authorities immediately.
              </p>
              <p>
                <strong>
                  KinShield does NOT provide legal advice, financial advice,
                  investment advice, tax advice, personal counseling,
                  psychological advice, or medical advice of any kind.
                </strong>{" "}
                No information, analysis, recommendation, or communication
                provided through KinShield constitutes professional advice or
                creates any professional-client relationship. Users requiring
                such advice should consult qualified professionals licensed in
                their jurisdiction.
              </p>
            </div>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Data Use and Licensing
            </h2>
            <p>
              By using KinShield, users grant Reliable IT Associates, LLC a
              non-exclusive, worldwide, royalty-free right to use, store,
              process, reproduce, analyze, and retain the information, content,
              and materials submitted to KinShield for the purposes of providing
              the Service, effective analysis, improving products and services,
              conducting research, generating anonymized fraud intelligence, and
              ensuring financial and legal compliance with all applicable laws
              and regulations. Anonymized and de-identified fraud intelligence
              derived from user-submitted scam data may be shared with law
              enforcement, government entities, industry partners, and fraud
              prevention organizations. Personally identifiable victim
              information is never shared; only scam-side artifacts are shared.
              Full details are provided in our Privacy Policy and Terms and
              Conditions.
            </p>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <section style={{ marginBottom: "30px" }}>
            <h2
              style={{
                paddingLeft: "15px",
                marginTop: "40px",
                marginBottom: "20px",
              }}
            >
              Limitation of Liability
            </h2>
            <div
              style={{
                backgroundColor: "#f8f8f8",
                border: "1px solid #ddd",
                padding: "20px",
                margin: "20px 0",
              }}
            >
              <p>
                <strong>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:
                </strong>
              </p>
              <p>
                Reliable IT Associates, LLC, its officers, directors, employees,
                agents, contractors, affiliates, licensors, and service
                providers disclaim all liability for any damages, losses,
                financial harm, identity theft, emotional distress, or any other
                direct, indirect, incidental, special, consequential, or
                punitive damages resulting from the use of or reliance upon
                KinShield's AI-generated analyses, recommendations, educational
                content, or any other aspect of the Service.
              </p>
              <p>
                <strong>
                  Any advice, analysis, alert, recommendation, or educational
                  content provided by KinShield — whether generated by AI or
                  otherwise — that may result in a user still falling victim to
                  a scam, fraud, phishing attack, social engineering scheme,
                  identity theft, or any other form of deception is NOT the
                  responsibility of KinShield or Reliable IT Associates, LLC,
                  and they shall not be liable for any resulting losses,
                  damages, or harm of any kind.
                </strong>
              </p>
              <p>
                KinShield does not guarantee, warrant, or represent that its
                Service will prevent users from falling victim to any scam,
                fraud, or cyberattack, regardless of the quality, thoroughness,
                or frequency of use of the Service. Users assume full
                responsibility for their digital security practices, decisions,
                and for independently verifying the legitimacy of any
                communication, transaction, or interaction.
              </p>
            </div>
          </section>

          <hr
            style={{
              border: "none",
              height: "2px",
              backgroundColor: "#ecf0f1",
              margin: "30px 0",
            }}
          />

          <div
            style={{
              textAlign: "center",
              fontStyle: "italic",
              color: "#666",
              marginTop: "30px",
              paddingTop: "20px",
              borderTop: "1px solid #ddd",
            }}
          >
            <p>
              <em>
                This disclosure statement is effective as of November 2025, was
                last updated on March 16, 2026, and may be updated periodically
                to reflect changes in our services or legal requirements. Users
                are responsible for reviewing current disclosure terms.
              </em>
            </p>
            <p style={{ marginTop: "20px" }}>
              <strong>
                © 2025-2026 Reliable IT Associates, LLC. All rights reserved.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclosures;
